
import { Outlet } from 'react-router-dom';
import styles from './MainLayout.module.css'
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import BlockGroup from './BlockGroup';
import SearchForm from './SearchForm';
import { useLanguage } from '../contexts/LanguageContext';
import getData from './Model';
 
// Главный макет
 
function MainLayout(){
    const { language } = useLanguage();
    const ui = getData('ui', language);
   
    // Determine which blocks to show based on language
    // You can customize this logic based on your needs
    const getBlocksToShow = () => {
        // Return different blocks based on language if needed
        // For now, show the same blocks in both languages
        return ['static', 'nodejs', 'php'];
    };
    
    const blocksToShow = getBlocksToShow();

    return ( 
        <div className={styles.MainLayout}>
            <Menu></Menu>
            <Header></Header>
            <SearchForm></SearchForm>
           
            <Outlet></Outlet>
            
            {/* Show blocks section only if there are blocks to display */}
            {blocksToShow.length > 0 && (
                <div className={styles.blocksSection}>
                    <h3 className={styles.blocksTitle}>
                        {language === 'eng' ? 'Technologies' : 'Технологии'}
                    </h3>
                    <BlockGroup items={blocksToShow}></BlockGroup>
                </div>
            )}
         
            <Footer></Footer>
        </div> 
    );
}

export default MainLayout;